import Vue from 'vue'
import VueRouter from 'vue-router'
import * as View from '@/views'

const guard = (to, from, next) => {
  next()
}

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: {name: 'Home'}
  },
  {
    path: '/tvsm',
    name: 'Home',
    component: View.Home,
    beforeEnter: guard,
    children: [
      {
        path: 'monitor/:serial',
        name: 'Monitor',
        component: View.Monitor,
        props: true
      }
    ]
  },
  {
    path: '/monitor/:serial',
    name: 'PopupMonitor',
    component: View.Monitor,
    props: true
  },
  {
    path: '/log/reservation',
    name: 'Log_Reservation',
    component: View.Log_Reservation
  },
  {
    path: '/log/webrtc',
    name: 'Log_WebRTC',
    component: View.Log_WebRTC
  },
  {
    path: '/manage/remote',
    name: 'Manage_Remote',
    component: View.Manage_Remote
  },
  {
    path: '/manage/user',
    name: 'Manage_User',
    component: View.Manage_User
  },
  {
    path: '/manage/doctor',
    name: 'Manage_Doctor',
    component: View.Manage_Doctor
  },
  {
    path: '/manage/group',
    name: 'Manage_Group',
    component: View.Manage_Group
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
